import React from 'react';
import { withTranslation } from 'react-i18next';

const CallAction = ({ t }) => {
    return (
        <div className="call-to-action-wrapper call-to-action text-white-wrapper ptb--120">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="inner text-center">
                            <span>{t("call to action-1")}</span>
                            <h2>{t("call to action-2")}</h2>
                            <a className="rn-button-style--2" href="/contact">
                                <span>{t("Contact button")}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withTranslation()(CallAction);
